<template>
  <section class="purchase-summary-card d-flex flex-column align-items-center">
    <h2 class="purchase-summary-card__title">{{ $t("portalHome.purchases.title") }}</h2>

    <div class="purchase-summary-card__rows">
      <div v-for="(row, index) in purchases" :key="index" class="purchase-summary-card__row">
        <img class="purchase-summary-card__icon" :src="purchaseIconSrc(index)" alt="" aria-hidden="true" />
        <div class="purchase-summary-card__row-text d-flex flex-wrap justify-content-between align-items-center">
          <span class="purchase-summary-card__minimum">{{ $t(row.minimumKey) }}</span>
          <span class="purchase-summary-card__count"
            :class="{ 'purchase-summary-card__count--faded': row.countFaded }">{{ $t("portalHome.units.piecesCount", {
              count: row.count }) }}</span>
        </div>
      </div>
    </div>

    <router-link
      v-if="canOpenPurchaseDetails"
      :to="{ name: 'pointsOverview' }"
      class="purchase-summary-card__button"
    >
      {{ $t("portalHome.purchases.detailsButton") }}
    </router-link>
    <button
      v-else
      type="button"
      class="purchase-summary-card__button"
      disabled
    >
      {{ $t("portalHome.purchases.detailsButton") }}
    </button>
  </section>
</template>

<script setup>
import { defineProps } from "vue";
import { usePortalPurchaseDetailsLink } from "@/composables/usePortalPurchaseDetailsLink";
import { portalHomeIcons } from "./portalHomeAssets";

const { canOpenPurchaseDetails } = usePortalPurchaseDetailsLink();

defineProps({
  purchases: { type: Array, required: true },
  purchasesYear: { type: Number, default: null },
});

function purchaseIconSrc(index) {
  return portalHomeIcons.purchases[index] || portalHomeIcons.purchases[0];
}
</script>

<style scoped lang="scss">
@import "@/styles/portal-home/purchase-summary-card";
</style>
